import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';

import { AuthStateService } from '../../auth/auth-state.service';
import { Logger } from '../../logging/logger.service';

export const authHeaderInterceptor: HttpInterceptorFn = (req, next) => {
  const logger = inject(Logger);
  const authStateService = inject(AuthStateService);
  const authToken = authStateService.token();

  logger.debug('Applied auth interceptor', {
    feature: 'http',
    operation: 'auth-header',
    severity: 'low',
  });

  if (!authToken) {
    logger.debug('No auth token present, skipping auth header', {
      feature: 'http',
      operation: 'auth-header',
      severity: 'low',
    });

    return next(req);
  }

  const requestWithAuth = req.clone({
    setHeaders: {
      Authorization: `Basic ${authToken}`,
    },
  });

  return next(requestWithAuth);
};
